import { render, staticRenderFns } from "./scientificDraw.vue?vue&type=template&id=14735c2f&scoped=true"
import script from "./scientificDraw.vue?vue&type=script&lang=js"
export * from "./scientificDraw.vue?vue&type=script&lang=js"
import style0 from "./scientificDraw.vue?vue&type=style&index=0&id=14735c2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14735c2f",
  null
  
)

export default component.exports